import BCPiramide from "../../shared/components/Bc-Piramide/Bc-piramide"
import LayoutMain from "../../shared/layouts/LayoutMain/LayoutMain"

const Piramide = () => {
    return(
        <LayoutMain idPage="Piramide" titlePage={true} >
        <BCPiramide />
    </LayoutMain>
    )
}

export default Piramide